module.exports = __webpack_public_path__ + "course-catalog-no-search-result-penguinwp112df3528cabccbc62c19bf88d8b6fd7.png";